import styles from './BulletSeparator.module.scss';

interface BulletSeparatorProps {
  style?: React.CSSProperties;
}

export const BulletSeparator: React.FC<BulletSeparatorProps> = ({ style }) => {
  return <span className={styles.bulletSeparator} style={style} aria-hidden="true" />;
};
